module.exports = __webpack_public_path__ + "static/media/skyl-l.e5ded871.mp3";